import moment from "moment-timezone";

const ARGENTINA_TZ = "America/Argentina/Buenos_Aires";

// "Today" for prescriptions is the Argentine calendar day, whatever the browser zone is.
export const todayArgentina = () => moment().tz(ARGENTINA_TZ).format("YYYY-MM-DD");

// A default filled in before midnight can be in the past by the time it is used.
const notBeforeToday = (date) => {
  const today = todayArgentina();
  return date < today ? today : date;
};

// Surfaces the server validation message on a 400 (valid_from before today).
export const getRequestErrorMessage = (error, fallback) => {
  const response = error?.response;
  return (response?.status === 400 && (response?.data?.message || response?.data?.detail)) || fallback;
};

export const buildMedicationItem = ({
  values,
  medication,
  diagnosisLabel,
  posology,
}) => {
  const diagnosis = diagnosisLabel || values.diagnosis;
  return {
    id: Math.random().toString(), // NOSONAR
    diagnosis,
    primary: diagnosis,
    name: medication.label,
    quantity: values.quantity,
    posology: posology && posology !== "" ? posology : null,
    extended: values.extended,
    vih: values.vih,
    substitution: values.substitution,
    ...(values.valid_from ? { valid_from: notBeforeToday(values.valid_from) } : {}),
    sale_type: medication?.sale_type || "NO_CLASIFICADO",
  };
};

// Shapes one medication for the request. The server computes the expiration, so it never goes out.
export const buildMedicationRequest = (medication) => {
  const {
    id,
    primary,
    expiration_date,
    expirationDate,
    experitionDate,
    validFrom,
    ...request
  } = medication;
  if (validFrom && !request.valid_from) {
    request.valid_from = validFrom;
  }
  return request;
};

export const addMedicationItem = (list, item) => [item, ...list];
